<template>
  <!-- -->
  <div class="roles-merchant">
    <separate-page right-back-ground="none" :show-border="true" :show-shadow="false">
      <template #category>
<!--        <yq-empty description="请先添加角色" v-if="roleList.length === 0"/>-->
<!--        <div v-else :class="currentRole.id === role.id? 'role-list on': 'role-list'" v-for="role in roleList" @click="selectRole(role)">{{role.roleName}}</div>-->
        <tree-dictionary :add-first-level-all="false" :filter="true" code-name="id" label-name="roleName" @clickCategory="selectRole"
                         right-add="sys:role:add" right-edit="sys:role:save" right-delete="sys:role:delete"
                         :query-function="queryRoles4TreeApi" :delete-function="deleteRole4TreeApi" :save-function="editRole4TreeApi" dialog-label="角色/岗位编辑">
          <template #default="{data}">
            <span class="node-name">{{ data.roleName }}</span>
            <el-tag v-if="data.businessType" size="small" type="warning" style="margin-left: 0.4rem">
              {{ businessTypeName(data.businessType) }}
            </el-tag>
          </template>
          <template #edit="{categoryData}">
            <form-items :data="categoryData" :columns="1" label-width="2.4rem" icon-width="0">
              <form-item label="名称" :required="true" name="roleName" error-message="请输入角色名称">
                <el-input v-model="categoryData.roleName" placeholder="角色名称，或岗位名称"/>
              </form-item>
              <form-item label="岗位">
                <el-select v-model="categoryData.businessType" placeholder="可选，选择后该角色同时作为岗位" clearable>
                  <el-option v-for="t in businessTypeList" :key="t.id" :label="t.dictName" :value="t.dictCode"/>
                </el-select>
              </form-item>
              <form-item label="角色分类" :required="true" name="roleType" error-message="请选择角色分类">
                <el-select v-model="categoryData.roleType" placeholder="请选择角色分类">
                  <el-option :value="1" label="超级管理员"/>
                  <el-option :value="2" label="普通角色"/>
                </el-select>
              </form-item>
              <form-item label="描述">
                <el-input type="textarea" v-model="categoryData.roleDescription"/>
              </form-item>
            </form-items>
          </template>
        </tree-dictionary>
      </template>
      <template #default>
        <list-page :show-shadow="false">
          <table-list :show-shadow="false" :show-border="false">
            <div v-if="currentRole.roleType === 1" style="height: 100%;background: #FFF;">
              <yq-empty description="超级管理员不能修改权限"/>
            </div>
            <separate-page v-else :show-border="false" :show-shadow="false">
              <template #category>
                <tree-dictionary :disabled="true" v-model="roleModules" :filter="true" code-name="id" label-name="moduleName" @clickCategory="clickModule">
                  <template #treeOption="{data}">
                    <span v-if="data.selected" style="color: #1EBD43"><yq-icon name="element-ui_check"/></span>
                  </template>
                </tree-dictionary>
              </template>
              <template #default>
                <access-module-component ref="moduleAccessComponent" v-model="currentModule.accessModule" :right-list="rightList" :module-access-right="currentModule.moduleAccess"/>
              </template>
            </separate-page>
          </table-list>
          <form-page :show-page="false" >
            <page-button hasPerm="sys:role:grant" el-type="success" :disabled="!currentRole.id" @click="toShowGrantAllModule">按功能授权</page-button>
            <page-button hasPerm="sys:role:grant" el-type="success" :disabled="!currentRole.id" @click="showShowGrantCopy">复制权限</page-button>
            <page-button hasPerm="sys:role:grantSave" el-type="primary" :disabled="!currentModule.id" @click="saveGrant">保存授权</page-button>
            <page-button hasPerm="sys:role:grantRemove" el-type="danger" :disabled="!currentModule.accessId" @click="deleteGrant">删除授权</page-button>
          </form-page>
        </list-page>
      </template>
    </separate-page>
    <el-dialog v-model="showEditRole" dialog-width="1" title="角色编辑" :close-on-click-modal="false">
      <el-form label-width="2.4rem">
        <el-form-item label="角色名称">
          <el-input v-model="editRole.roleName" placeholder="请输入角色名称"/>
        </el-form-item>
        <el-form-item label="角色分类">
          <el-select v-model="editRole.roleType" placeholder="请选择角色分类">
            <el-option :value="1" label="超级管理员"/>
            <el-option :value="2" label="普通角色"/>
          </el-select>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" v-model="editRole.roleDescription"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <page-button @click="showEditRole = false">取消</page-button>
        <page-button el-type="primary" @click="saveRole">保存</page-button>
      </div>
    </el-dialog>
    <el-dialog v-model="showCopyRight" title="复制授权" dialog-width="1">
      <el-form label-width="2.4rem">
        <el-form-item label="来源角色">
          <el-select v-model="copyRight.from">
            <el-option v-for="role in roleList" :key="role.id" :value="role.id" :label="role.roleName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="目标角色">
          <el-select v-model="copyRight.to">
            <el-option v-for="role in roleList" :key="role.id" :value="role.id" :label="role.roleName"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <page-button @click="showCopyRight = false">取消</page-button>
        <page-button el-type="primary" type="write" @click="saveCopyRight">保存</page-button>
      </div>
    </el-dialog>
    <el-dialog v-model="showAllGrantModule" title="全部授权" dialog-width="1" :close-on-click-modal="false">
      <form-items label-width="2.4rem" icon-width="0" :columns="1">
        <form-item label="授权角色">
          <el-select v-model="copyRight.roleId">
            <el-option v-for="role in roleList" :key="role.id" :value="role.id" :label="role.roleName"/>
          </el-select>
        </form-item>
        <form-item label="功能权限">
          <tree-select v-model="copyRight.grantedMenus" :tree-list="allModules" label-name="moduleName"/>
        </form-item>
      </form-items>
      <div slot="footer">
        <page-button @click="showAllGrantModule = false">取消</page-button>
        <page-button el-type="primary" type="write" @click="grantAllModule">保存</page-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import roleApi from "@/api/normal/sys/roleApi";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import AccessModuleComponent from "./AccessModuleComponent.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqIcon from "@/components/YqIcon.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TreeSelect from "@/components/h5/data/TreeSelect.vue";
import commonApi from "@/api/commonApi";
export default {
  props: {
    merchantId: {default: ""}
  },
  name: "",
  components: {
    TableButton,
    YqIcon,
    PageButton, TreeDictionary, FormItems, FormItem, TreeSelect,
    SeparatePage, AccessModuleComponent, ListPage, TableList, FormPage
  },
  data() {
    return {
      roleList: [],
      currentRole: {
        roleName: "",
      },
      // 全部的功能
      roleModules: [],
      allModules: [],
      showEditRole: false,
      editRole: {
        roleName: "",
        roleDescription: "",
        roleType: 2,
      },
      // 系统支持的全部的权限
      rightList: [],
      // 当前选中编辑的权限
      currentModule: {

      },
      copyRight: {
        from: "",
        to: "",
        right: 3,
        roleId: "",
      },
      // 复制授权
      showCopyRight: false,
      // 全部授权
      showAllGrantModule: false,
      // 岗位（角色业务类型）字典
      businessTypeList: [],
      // api委托
      queryRoles4TreeApi: null,
      editRole4TreeApi: null,
      deleteRole4TreeApi: null,
    };
  },
  created() {
    // 岗位类型字典：角色设置了 business_type 后同时作为岗位展示
    commonApi.queryUniqueDictionaryList("POSITION_ROLE").then(list => {
      this.businessTypeList = list || [];
    });
    // 查询全部的功能
    roleApi.queryAllModules(this.merchantId).then(list => {
      this.allModules = list;
      this.queryAllRoles();
    });
    // roleApi.queryAccessRight().then(list => this.rightList = list);
    // 树形节点api
    this.queryRoles4TreeApi = () => {
      return new Promise(resolve => {
        roleApi.queryAllRoles(this.merchantId).then(list => resolve(list));
      });
    };
    this.editRole4TreeApi = (data) => {
      return new Promise(resolve => {
        roleApi.saveRole(data).then(res => resolve(res));
      });
    };
    this.deleteRole4TreeApi = (data) => {
      return new Promise(resolve => {
        roleApi.delRole(data.id).then(res => resolve(res));
      });
    };
  },
  methods: {

    // 岗位名称（businessType 存 POSITION_ROLE 字典 code）
    businessTypeName(code) {
      const item = this.businessTypeList.find(t => t.dictCode === code);
      return item?.dictName || code;
    },
    // 查询角色列表
    queryAllRoles() {
      roleApi.queryAllRoles(this.merchantId).then(list => {
        this.roleList = list;
        // 选中第一个
        if (this.roleList.length > 0) {
          this.selectRole(this.roleList[0]);
        }
      });
    },
    // 保存角色基本信息
    saveRole() {
      let data = {...this.editRole};
      if (this.merchantId) {
        data.merchantId = this.merchantId;
      }
      roleApi.saveRole(data).then(() => {
        this.queryAllRoles();
        this.showEditRole = false;
      });
    },
    // 删除授权
    deleteGrant() {
      let id = this.currentModule.accessId;
      if (!id) {
        this.$message.error("尚未添加此功能的授权，不需要删除")
        return;
      }
      roleApi.deleteGrant(id).then(() => {
        this.selectRole(this.currentRole);
      });
    },
    // 保存授权
    saveGrant() {
      // 获取到所有的权限
      let data = {
        id: this.currentModule.accessId,
        moduleId: this.currentModule.id,
        roleId: this.currentRole.id,
        accessModule: this.currentModule.accessModule,
      };
      roleApi.saveGrant(data).then(() => {
        this.selectRole(this.currentRole);
      });
    },
    // 选中某个角色
    selectRole(role) {
      this.currentRole = role;
      // 选中某个角色，查询这个角色被授权的数据
      roleApi.queryGrantModules(role.id).then(list => {
        // 查询到的list，添加权限
        this.roleModules = this.getModuleAccess(this.allModules, list);
      });
    },
    // 角色授权功能的信息
    getModuleAccess(modules, list) {
      let arr = [];
      for (let i = 0; i < modules.length; i++) {
        let contains = false;
        let accessModule = "";
        let accessId = "";
        // 是否被授权
        for (let j = 0; j < list.length; j++) {
          if (modules[i].id === list[j].moduleId) {
            contains = true;
            accessModule = list[j].accessModule;
            accessId = list[j].id;
            break;
          }
        }
        let children = [];
        // 半选中
        let indeterminate = false;
        if (modules[i].children && modules[i].children.length > 0) {
          children = this.getModuleAccess(modules[i].children, list);
          if (children.length > 0) {
            for (let j = 0; j < children.length - 1; j++) {
              indeterminate = !!children[j].accessModule !== !!children[j+1].accessModule;
              if (indeterminate) {
                break;
              }
            }
          }
        }
        arr.push({
          ...modules[i],
          accessModule: accessModule,
          children: children,
          indeterminate: indeterminate, // 半选中状态
          selected: contains, // 是否选中
          accessId: accessId,
        })
      }
      console.log(arr)
      return arr;
    },

    async clickModule(data) {
      if (data.children && data.children.length > 0) {
        return;
      }
      this.rightList = await roleApi.queryAccessRight(data.id)
      this.currentModule = {...data}
      this.$refs.moduleAccessComponent.initData();
    },
    showShowGrantCopy() {
      this.copyRight.from = this.currentRole.id;
      this.copyRight.to = "";
      this.showCopyRight = true;
    },
    saveCopyRight() {
      if (!this.copyRight.from || !this.copyRight.to) {
        this.$message.error("请选择要复制的来源和目标角色");
        return;
      }
      roleApi.copyGrant(this.copyRight.from, this.copyRight.to).then(() => {
        this.$message.success("保存成功")
        this.showCopyRight = false;
      });
    },
    toShowGrantAllModule() {
      this.copyRight.roleId = this.currentRole.id;
      this.copyRight.right = 1;
      this.copyRight.grantedMenus = "4003,40030001";
      this.showAllGrantModule = true;
    },
    // 全部授权
    grantAllModule() {
      roleApi.allGrant(this.copyRight.roleId, this.copyRight.right, this.merchantId).then(() => {
        this.$message.success("保存成功");
        this.showAllGrantModule = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tree";
.roles-merchant{
  height: 100%;
  box-sizing: border-box;
  padding-top: 10px;
}
.role-list{
  font-size: 14px;
  line-height: 36px;
  cursor: pointer;
  padding: 0 10px;
}
.role-list.on{
  color: #409EFF;
}
.role-info{
  text-align: right;
}
.role-grant{
  height: calc(100% - 60px);
  overflow: auto;
}
.module{
  border-bottom: 1px solid #eaeaea;
  padding: 20px;
  .mo-info{
    line-height: 28px;
    .mo-title{
      display: inline-block;
      width: 220px;
    }
    .mo-content{
      display: inline-block;
    }
    .weight{
      font-weight: 600;
    }
  }
  .mo-info:nth-child(2n+1){
    background: #fafafa;
    border-bottom: 1px solid #fafafa;
  }
}
</style>